const cantons = ['AR','AI','AG','BA','BE','BL','BS','FR','GE','GL','GR','JU','LU','NE','NW','OW','SG','SH','SZ','SO','TI','TG','UR','VS','VD','ZG','ZH','74','01'];

export function hasCantons() {
    return cantons.includes(document.querySelector('#select-loc .custom-option-level').dataset?.['value'].toUpperCase())
}
